
import { getDocs, collection, query} from 'firebase/firestore';
import { db } from '../../../config/firebase-config';


const TABLE_NAME = "Configurations";

const ConfigCollectionRef = collection(db, TABLE_NAME);
const ConfigQueryAsc = query(ConfigCollectionRef);

//get Sections
export const fetchConfigurations = async () => {
    try {
        const data = await getDocs(ConfigQueryAsc);
        const filteredData = data.docs.map((doc) => ({
            ...doc.data(),
            Id: doc.id
        }))
        
        if(filteredData.length > 0)
        return filteredData[0];
        
        return [];

    } catch (error) {
        throw error;
    }
}
